import type { Dispute } from "@redotech/redo-dispute-db-schema/dispute-definition";

export const disputeQueueStates = [
  "merchant_action_required",
  "redo_handling",
  "waiting_on_provider",
  "done",
] as const;

export type DisputeQueueState = (typeof disputeQueueStates)[number];

const settledStatuses = new Set<Dispute["status"]>([
  "won",
  "lost",
  "accepted",
  "charge_refunded",
  "prevented",
]);

function isPast(date: Date | null | undefined): boolean {
  return date != null && date < new Date();
}

export function getDisputeQueueState(
  dispute: Pick<
    Dispute,
    | "aiEvidenceGeneratedAt"
    | "autoEvidenceDisabled"
    | "evidenceDueBy"
    | "evidenceSentOn"
    | "shopifyProtectStatus"
    | "status"
  >,
  automateEvidenceEnabled: boolean,
): DisputeQueueState {
  if (
    dispute.shopifyProtectStatus === "PROTECTED" ||
    settledStatuses.has(dispute.status)
  ) {
    return "done";
  }

  if (dispute.evidenceSentOn || dispute.status === "under_review") {
    return "waiting_on_provider";
  }

  if (isPast(dispute.evidenceDueBy)) {
    return "merchant_action_required";
  }

  if (
    dispute.status === "needs_response" &&
    automateEvidenceEnabled &&
    !dispute.autoEvidenceDisabled
  ) {
    return "redo_handling";
  }

  return "merchant_action_required";
}
